// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"42384":"f97c888ca239b026","45279":"db90672f38e66f54","55227":"4efe9d5dca467492"}[chunkId] + ".css";
};